"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopView = DesktopView;
exports.TabletAndMobileView = TabletAndMobileView;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DesktopView(_ref) {
  var {
    rollUpRate,
    rollUpPeriod,
    interestRollUp
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-desktop-only"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-5 col-lg-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-7"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Roll-up rate")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, rollUpRate)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-7 col-lg-7"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Roll-up period")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto col-lg-5"
  }, rollUpPeriod)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-lg-7"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Interest")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, interestRollUp))))));
}
function TabletAndMobileView(_ref2) {
  var {
    rollUpRate,
    rollUpPeriod,
    interestRollUp
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-tablet-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-7 col-md-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-7"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Roll-up rate")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, rollUpRate)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-7"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Roll-up period")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, rollUpPeriod)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-7"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Interest")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, interestRollUp))))));
}